import OliverText from "@builder/components/general/OliverText";
import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";
import DropdownInput from "../../../ActionDropdown";
import Toggle from "@builder/components/general/Toggle";

const roundingOptions = {
    "": "Do not round",
    "0.05": "Round to nearest 0.05",
    "0.10": "Round to nearest 0.10",
    "0.25": "Round to nearest 0.25",
    "0.50": "Round to nearest 0.50",
    "1.00": "Round to nearest 1.00"
};

const CashPaymentAction = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [paymentDetails, setPaymentDetails] = useState<any>(
        actionStep?.action?.data || {
            addedFee: { value: "", type: "$" },
            addedDiscount: { value: "", type: "$" },
            tips: {
                request: false,
                customTip1: { label: "", amount: { value: "", type: "%" } },
                customTip2: { label: "", amount: { value: "", type: "%" } },
                customTip3: { label: "", amount: { value: "", type: "%" } },
                allowCustomTips: false,
                allowNoTips: false
            },
            cashRounding: "",
            changeCalculator: false
        }
    );
    const dispatch = useAppDispatch();

    const updateNodeProperty = (propertyPath: string[], value: any) => {
        setPaymentDetails((prev: any) => {
            const newDetails = { ...prev };

            let current = newDetails;
            for (let i = 0; i < propertyPath.length - 1; i++) {
                current[propertyPath[i]] = { ...current[propertyPath[i]] };
                current = current[propertyPath[i]];
            }

            current[propertyPath[propertyPath.length - 1]] = value;

            return newDetails;
        });
    };

    // const handleAmount = (value: string, key: "addedFee" | "addedDiscount") => {
    //     updateNodeProperty([key, "value"], value);
    // };

    // const handleToggle = (key: "addedFee" | "addedDiscount") => {
    //     setPaymentDetails((prevDetails: any) => {
    //         const updatedDetails = { ...prevDetails };
    //         const updatedKey = { ...updatedDetails[key] };

    //         updatedKey.type = updatedKey.type === "$" ? "%" : "$";

    //         updatedDetails[key] = updatedKey;

    //         return updatedDetails;
    //     });
    // };

    const handleRoundingChange = (value: string) => {
        updateNodeProperty(["cashRounding"], value);
    };

    const handleChangeCalculatorToggle = () => {
        updateNodeProperty(["changeCalculator"], !paymentDetails.changeCalculator);
    };

    const handleCustomTipChange = (index: 1 | 2 | 3, value: string, type: "%" | "$") => {
        updateNodeProperty(["tips", `customTip${index}`, "amount"], { value, type });
    };

    const handleCustomTipLabelChange = (index: 1 | 2 | 3, label: string) => {
        updateNodeProperty(["tips", `customTip${index}`, "label"], label);
    };

    const handleAllowCustomTipsToggle = () => {
        updateNodeProperty(["tips", "allowCustomTips"], !paymentDetails.tips?.allowCustomTips);
    };

    const handleAllowNoTipsToggle = () => {
        updateNodeProperty(["tips", "allowNoTips"], !paymentDetails.tips?.allowNoTips);
    };

    useEffect(() => {
        const action = {
            type: ActionType.CASH_PAYMENT,
            data: paymentDetails
        };

        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [paymentDetails, actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <DropdownInput
                    title="Cash rounding"
                    layout="column"
                    options={roundingOptions}
                    callback={handleRoundingChange}
                    bold
                    value={paymentDetails.cashRounding || ""}
                />

                <div className="function-checkbox-wrapper">
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Show change calculator" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will show the calculator box" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <div style={{ width: "fit-content" }}>
                        <Toggle callback={handleChangeCalculatorToggle} checked={paymentDetails.changeCalculator || false} label="" />
                    </div>
                </div>

                {/* <div className="function-add-cart-note-wrapper">
                    <TextInput
                        title="Add fee"
                        callback={value => handleAmount(value, "addedFee")}
                        value={paymentDetails.addedFee?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedFee");
                            }
                        }}
                        isPercent={paymentDetails.addedFee?.type === "%"}
                    />
                    <TextInput
                        title="Add discount"
                        callback={value => handleAmount(value, "addedDiscount")}
                        value={paymentDetails.addedDiscount?.value || ""}
                        className="actions-tab-input"
                        placeholder="Amount"
                        icon={{
                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                            callback: (event: React.MouseEvent) => {
                                event.preventDefault();
                                handleToggle("addedDiscount");
                            }
                        }}
                        isPercent={paymentDetails.addedDiscount?.type === "%"}
                    />
                </div> */}

                {paymentDetails.tips?.request && (
                    <>
                        <div style={{ display: "flex", width: "100%", flexDirection: "column", gap: "16px" }}>
                            <OliverText text="Tips" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                            {[1, 2, 3].map(index => (
                                <div key={index} style={{ display: "flex", width: "100%", justifyContent: "space-between", gap: "16px" }}>
                                    <TextInput
                                        title=""
                                        callback={value => handleCustomTipLabelChange(index as 1 | 2 | 3, value)}
                                        value={paymentDetails.tips?.[`customTip${index}`]?.label || ""}
                                        className="actions-tab-input tips-input"
                                        placeholder={["Good", "Great", "Awesome"][index - 1]}
                                    />
                                    <TextInput
                                        callback={value =>
                                            handleCustomTipChange(
                                                index as 1 | 2 | 3,
                                                value,
                                                paymentDetails.tips?.[`customTip${index}`]?.amount.type || "$"
                                            )
                                        }
                                        value={paymentDetails.tips?.[`customTip${index}`]?.amount.value || ""}
                                        className="actions-tab-input tips-input"
                                        placeholder={["15", "20", "25"][index - 1]}
                                        icon={{
                                            src: ["./dollar-sign.svg", "./percentage-sign.svg"],
                                            callback: (event: React.MouseEvent) => {
                                                event.preventDefault();
                                                handleCustomTipChange(
                                                    index as 1 | 2 | 3,
                                                    paymentDetails.tips?.[`customTip${index}`]?.amount.value || "",
                                                    paymentDetails.tips?.[`customTip${index}`]?.amount.type === "$" ? "%" : "$"
                                                );
                                            }
                                        }}
                                        isPercent={paymentDetails.tips?.[`customTip${index}`]?.amount.type === "%"}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="function-checkbox-wrapper">
                            <div className="function-checkbox-label-wrapper">
                                <OliverText text="Allow custom tips" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                                <OliverText
                                    text="The customer can input custom tips"
                                    size="xs"
                                    weight="light"
                                    translatePrefix="popup.actionBuilder."
                                />
                            </div>
                            <div style={{ width: "fit-content" }}>
                                <Toggle callback={handleAllowCustomTipsToggle} checked={!!paymentDetails.tips?.allowCustomTips} label="" />
                            </div>
                        </div>
                        <div className="function-checkbox-wrapper">
                            <div className="function-checkbox-label-wrapper">
                                <OliverText text="Allow no tips" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                                <OliverText
                                    text="The customer will see a no tip option"
                                    size="xs"
                                    weight="light"
                                    translatePrefix="popup.actionBuilder."
                                />
                            </div>
                            <div style={{ width: "fit-content" }}>
                                <Toggle callback={handleAllowNoTipsToggle} checked={!!paymentDetails.tips?.allowNoTips} label="" />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CashPaymentAction;
